import Local from '../classes/local';
import english from '../smartling/en.json';
import spanish from '../smartling/es.json';
import setLanguage from './setLanguage';

export type TranslationKey = keyof typeof english;

export default function translate(key: TranslationKey, replacements = {}) {
    setLanguage();
    const replace = (text: string) => {
        let replacedText = text;
        Object.entries(replacements).forEach(entry => {
            const [target, replacement] = entry as [string, string];
            const pieces = replacedText.split(`{{${target}}}`);
            replacedText = pieces.join(replacement.toString());
        });
        return replacedText.toString();
    };

    const language: 'English' | 'Spanish' = Local.getItem('language') || 'English';
    const englishString = english[key];
    let spanishString = englishString;
    if (key in spanish) {
        // @ts-ignore
        spanishString = spanish[key];
    }

    const string = language === 'English' ? englishString : spanishString;
    return replace(string);
}
